import React, {useState} from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Hidden, Grid } from "@material-ui/core";
import Navbar from "./Navbar";
import Header from "./Header";
import * as constants from "../../constants"
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
}))

const Appbar = ({title}) => {
  const classes = useStyles()
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  if(navigator.onLine){
    window.addEventListener("online", () => {
      constants.checkLocalData(constants.ADD_PRODUCT_URL, constants.localStorageKeys.product)
      constants.saveLocalSignUpData(constants.ADD_STORE_URL, constants.localStorageKeys.store)
      constants.saveLocalComments();
    })
  }
  return(
    <>
      <Grid container>
        <Grid item sm={2}>
          <nav className={classes.drawer}>
            <Hidden smUp implementation="js">
              <Navbar 
                PaperProps={{ style: { width: drawerWidth } }}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
              />
            </Hidden>
            <Hidden xsDown implementation="css">
              <Navbar PaperProps={{ style: { width: drawerWidth } }} />
            </Hidden>
          </nav>
        </Grid>
        <Grid item sm={10} xs={12}>
          <Header onDrawerToggle={handleDrawerToggle} title={title} />
        </Grid>
      </Grid>
    </>
  )
}

export default Appbar;